// extracted by mini-css-extract-plugin
export default {"wrapper":"gameLogs_wrapper__93Q8Y","number":"gameLogs_number__wuv2q","log":"gameLogs_log__BxBJj"};